var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0822 15.5263C17.8229 15.7853 17.7038 16.1598 17.7629 16.527L18.6528 21.6027C18.7279 22.0329 18.5517 22.4683 18.2023 22.7169C17.86 22.9748 17.4045 23.0058 17.0311 22.7994L12.5974 20.4163C12.4432 20.3317 12.2721 20.2863 12.0969 20.2812H11.8256C11.7315 20.2956 11.6394 20.3266 11.5553 20.374L7.12062 22.7685C6.90139 22.882 6.65312 22.9222 6.40987 22.882C5.81724 22.7664 5.42182 22.1846 5.51892 21.5707L6.40987 16.495C6.46893 16.1247 6.3498 15.7481 6.09053 15.4851L2.47571 11.8743C2.17339 11.572 2.06828 11.1181 2.20642 10.7085C2.34057 10.3 2.68293 10.0019 3.09636 9.93481L8.07162 9.19099C8.45002 9.15076 8.78237 8.91348 8.95255 8.56272L11.1449 3.93063C11.1969 3.82747 11.264 3.73255 11.3451 3.65209L11.4352 3.57987C11.4822 3.52622 11.5363 3.48186 11.5963 3.44576L11.7055 3.40449L11.8756 3.33228H12.2971C12.6735 3.37251 13.0048 3.60463 13.178 3.95126L15.3994 8.56272C15.5595 8.90007 15.8709 9.13425 16.2302 9.19099L21.2055 9.93481C21.6259 9.99671 21.9773 10.2959 22.1165 10.7085C22.2476 11.1222 22.1345 11.5762 21.8262 11.8743L18.0822 15.5263Z",
    fill: "#FFB800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.42cea2847c2049a3f505b47137355e8e.svg";
export { ForwardRef as ReactComponent };